import { render } from "./AtuadoresSobIA.vue?vue&type=template&id=20182ad4&scoped=true"
import script from "./AtuadoresSobIA.vue?vue&type=script&lang=js"
export * from "./AtuadoresSobIA.vue?vue&type=script&lang=js"

import "./AtuadoresSobIA.vue?vue&type=style&index=0&id=20182ad4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20182ad4"]])

export default __exports__